import { ReactNode } from "react";
import Navbar from "@/components/Navbar";
import Footer from "@/components/Footer";
import StickyShopBar from "@/components/StickyShopBar";

interface LayoutProps {
  children: ReactNode;
  showStickyBar?: boolean;
}

const Layout = ({ children, showStickyBar = false }: LayoutProps) => {
  return (
    <div className="min-h-screen bg-background">
      <Navbar />
      {showStickyBar && <StickyShopBar />}
      <main>{children}</main>
      <Footer />
      {showStickyBar && <div className="h-14 md:h-16" />}
    </div>
  );
};

export default Layout;
